import React from 'react';

import { CaseChallengeItemModel, CaseChallengesTabContent } from '../case-challenges-tab-content';

export const Case3ChallengesTabContent = React.memo(() => {
  const Case3Challenges = React.useMemo<CaseChallengeItemModel[]>(() => {
    const case1Challenges: CaseChallengeItemModel[] = [
      {
        type: 'default',
        icon: 'invoice',
        text:
          'Inaccurate and delayed bills lead to revenue leakage, subscriber dissatisfaction and increased call centre costs for operators',
      },
      {
        type: 'default',
        icon: 'phone',
        text: 'Failed mobile top-ups lead to revenue leakage for operators',
      },
      {
        type: 'spacer',
      },
    ];

    return case1Challenges;
  }, []);

  return <CaseChallengesTabContent items={Case3Challenges} />;
});
